import React from 'react';
import {AisinoFormItem, AisinoRadio, AisinoRadioGroup} from "../../../baseComponent/form";
import {formItemTailLayout} from "../../../constant/css";


class FormItemRadio extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            optionsData: '',
        };
    }

    componentDidMount() {
        const optionList = this.props.optionlist;

        if (optionList){
            let children = [];
            for (let i = 0; i < optionList.length; i++) {
                children.push(<AisinoRadio key={optionList[i].name} value={optionList[i].value}>{optionList[i].name}</AisinoRadio>);
            }
            this.setState({optionsData:children});
        }
    }

    onChange = e => {
        // console.log('radio checked', e.target.value);
        this.setState({
            value: e.target.value,
        });
    };

    render() {
        return(
            <AisinoFormItem {...formItemTailLayout}
                            {...this.props} onChange={this.props.onChangeItem}>
                <AisinoRadioGroup onChange={this.onChange} value={this.state.value} {...this.props}>
                    {this.state.optionsData}
                </AisinoRadioGroup>
            </AisinoFormItem>
        );
    }
}

export default FormItemRadio;